module.exports = __webpack_public_path__ + "img/bg-account.66d52c0c.jpg";